/**
 * Operator of the platform (the termin.quest website itself). Shown on /impressum
 * and /datenschutz. Replace the placeholders before going live.
 */
export const PLATFORM = {
  name: 'termin.quest',
  operator: 'Vorname Nachname', // TODO: Betreiber:in / Firma inkl. Rechtsform
  address: 'Musterstraße 1, 10115 Berlin', // TODO
  email: 'kontakt@termin.quest', // TODO
  phone: undefined as string | undefined,
  vatId: undefined as string | undefined,
  /** Processors listed in the privacy notice (Art. 28 DSGVO). */
  processors: {
    hosting: 'Cloudflare, Inc. (Auslieferung der Website, CDN)',
    database: 'Supabase Inc. (Datenbank, Serverstandort Frankfurt am Main)',
    email: 'Brevo (Sendinblue SAS, Paris) – Versand von Bestätigungs- und Erinnerungs-E-Mails',
  },
} as const;
